// todo kb interactions yes/no? - punting on this for now, some odd interactions making this harder than expected
import { html, LitElement, css } from 'lit-element';
import _ from 'lodash';
import { debounce } from 'throttle-debounce';
import { withDropdownEvents } from '@trumedianetworks/tmn-core-components/src/util/dropdown-events-mixin';
import '@trumedianetworks/tmn-core-components/src/tmn-button';
import '@trumedianetworks/tmn-core-components/src/tmn-checkbox';
import '@trumedianetworks/tmn-core-components/src/util/tmn-click-away-listener';

//export class LeagueSearch extends withDropdownEvents(LitElement) {
export class LeagueSearch extends LitElement {
    constructor() {
        super();
        this.placeholderText = '';
        this.searchValue = '';
        this.visible = false;
        this.searchResults = [];
        this.data = [];
        this._letterButtons = [];
        this.autocompleteSearchDebounced = debounce(200, this.autocompleteSearch);
        this._handleModalKeyDown = this._handleGeneralKeyDown.bind(this);
        this._showAll = false;
        this.selectedData = [];
    }

    static get styles() {
        return [
            css`
                :host {
                    display: flex;
                    position: relative;
                }
                tmn-click-away-listener {
                    display: flex;
                }
                tmn-click-away-listener > div {
                    min-width: 400px;
                }
                tmn-checkbox {
                    display: flex;
                }
                input {
                    padding: 2px 16px 2px 32px;
                    height: 27px;
                    width: 100%;
                    border: 1px solid var(--app-on-background-color);
                    border-radius: 4px;
                    background: #f1f3f4;
                    -webkit-transition: all 0.3s linear;
                    transition: all 0.3s linear;
                    text-overflow: ellipsis;
                    overflow: hidden;
                    font-family: 'Lato', sans-serif;
                    font-size: 14px;
                }

                input:focus {
                    background-color: var(--app-background-color);
                    border: 0;
                    color: var(--app-on-primary-light-color);
                }

                .tmn-dropdown-menu {
                    display: none;
                    position: absolute;
                    z-index: 1;
                    width: 600px;
                    margin: -40px -40px 0px -10px;
                    border-radius: 8px;
                    background-color: var(--app-background-color);
                    border: 1px solid var(--app-primary-dark-color);
                    background-clip: padding-box;
                    flex-direction: column;
                }
                .tmn-dropdown-menu[visible] {
                    display: flex;
                }
                .search-placeholder {
                    height: 45px;
                    display: flex;
                    justify-content: flex-end;
                    align-items: center;
                    --tmn-icon-font-size: 18px;
                }

                .search-placeholder > span {
                    margin: 0px 4px 0 0;
                }

                .tmn-dropdown-label {
                    background-color: var(--app-primary-color);
                    padding: 8px;
                }
                .tmn-dropdown-label h3 {
                    margin: 0;
                    color: var(--app-on-primary-color);
                    text-transform: capitalize;
                }

                .tmn-dropdown-items {
                    max-height: 210px;
                    overflow-y: auto;
                }
                .tmn-dropdown-item {
                    padding: 0 0 0 10px;
                }

                .results-list {
                    min-width: 450px;
                }

                .result-controls {
                    border-top: 1px solid var(--app-secondary-color);
                    padding: 8px;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                }

                .search-helpers {
                    max-height: 350px;
                    overflow-y: auto;
                    max-width: 650px;
                    justify-content: center;
                    align-items: center;
                    flex-flow: column;
                    display: flex;
                }
                .search-helpers > * {
                    padding: 10px;
                }

                .letter-buttons {
                    display: grid;
                    grid-template-rows: repeat(2, auto);
                    grid-auto-flow: column;
                    border-bottom: 1px solid var(--app-secondary-color);
                }

                .no-results {
                    display: flex;
                    font-weight: 600;
                    font-size: 1rem;
                    color: var(--app-primary-color);
                    justify-content: center;
                    align-items: center;
                    padding: 12px;
                }

                .tmn-dropdown-item[kb-selected],
                .tmn-dropdown-item:hover {
                    background-color: var(--app-primary-light-color);
                }

                tmn-icon {
                    color: grey;
                    width: 18px;
                    height: 18px;
                    position: absolute;
                    top: 50%;
                    left: 7px;
                    margin-top: -9px;
                }

                .search-container {
                    position: relative;
                    margin: 0;
                    padding: 0;
                    border: 0;
                }
                :host([visible]) .search-container {
                    z-index: 2;
                }
            `,
        ];
    }

    static get properties() {
        return {
            placeholderText: {
                type: String,
            },
            queries: {
                type: Array,
            },
            searchValue: {
                type: String,
            },
            searchResults: {
                type: Array,
            },
            data: {
                type: Array,
            },
            visible: {
                type: Boolean,
                reflect: true,
            },
            currentQuery: {
                type: Object,
            },
            _KBSelectedIndex: {
                type: Number,
            },
            _letterButtons: {
                type: Array,
            },
            _showAll: {
                type: Boolean,
            },
            selectedData: {
                type: Array,
            },
        };
    }

    firstUpdated() {
        this.addEventListener('keydown', this._handleGeneralKeyDown);
    }

    updated(changedProps) {
        if (changedProps.has('data')) {
            const { data } = this;
            if (data?.length) {
                this._letterButtons = _.uniq(data.map(({ displayKey }) => displayKey[0])).sort();
                //console.log(_.countBy(data.map(({ displayKey }) => displayKey[0])));
            }
            if (data) {
                // this is necessary to keep results in sync when we change the available data (i.e. b/c we selected something)
                // would be good to remove the intermediary here (searchResults) but it is fairly tied up with the kb events
                this.searchResults = this.getFilteredData();
            }
        }
    }

    render() {
        // todo not sure why clickaway listener isn't working if clicking form (maybe tab group getting it?) at any rate, maybe we don't need it
        const { visible, placeholderText, searchValue, selectedData } = this;
        const selectedCount = selectedData?.length;
        return html`
            <tmn-click-away-listener @click-away=${this.handleMenuCloseEvent} ?active=${visible}>
                <div>
                    <div class="search-container">
                        <tmn-icon icon="search"></tmn-icon>
                        <input
                            id="search-input"
                            type="text"
                            .placeholder=${placeholderText}
                            autocomplete="off"
                            @keyup=${this.valueChanged}
                            @focusin=${this._focusin}
                            .value=${searchValue} />
                    </div>
                    <div class="tmn-dropdown-menu" ?visible="${visible}">
                        <div class="search-placeholder">
                            <span>${selectedCount ? html`${selectedCount} selected` : null}</span>
                            <tmn-icon-button @click=${this.handleMenuCloseEvent}>
                                <tmn-icon icon="close"></tmn-icon
                            ></tmn-icon-button>
                        </div>
                        ${this.renderSearchDetails()}
                    </div>
                </div>
            </tmn-click-away-listener>
        `;
    }

    autocompleteSearch() {
        this.searchResults = this.getFilteredData();
    }

    handleLetterSearch(e) {
        const letter = e.detail.value;
        this.searchValue = letter;
        // probably overkill here, but we could mimic github with something like startsWith:'A' in the search box
        // another option is only use startswith if there is exactly one char
        this.searchResults = this.getFilteredData();
    }

    handleShowAll() {
        this._showAll = true;
    }

    renderSearchDetails() {
        const { searchValue, searchResults, _showAll } = this;
        if (searchValue && !searchResults?.length && !_showAll) {
            return html` ${this.renderNoResults()} `;
        }
        return html`
            <div class="results-list">
                <div class="tmn-dropdown-label">${this.renderLabel('Leagues')}</div>
                ${searchValue || _showAll ? this.renderResults() : this.renderSearchHelpers()}
            </div>
        `;
    }

    renderSearchHelpers() {
        const { _letterButtons } = this;
        return html`<div class="search-helpers">
            <div class="letter-buttons">
                ${_letterButtons.map((buttonLabel, idx) => {
                    return html`
                        <tmn-icon-button
                            @click=${this.handleLetterSearch}
                            variant="rectangle"
                            color="primary"
                            iconset=""
                            .value=${buttonLabel}
                            >${buttonLabel}</tmn-icon-button
                        >
                    `;
                })}
            </div>
            <tmn-button @click=${this.handleShowAll} color="primary" variant="outlined"
                >Show All Leagues</tmn-button
            >
        </div>`;
    }

    // naming etc
    renderResults() {
        let startIdx = 0;
        const { searchResults, _showAll, data, selectedData } = this;
        const results = _showAll ? data?.slice(0) : searchResults;
        const controlsDisabled = !selectedData?.length;
        return html`<div class="tmn-dropdown-items">
                ${results.map((item, idx) => {
                    return html`
                        <div
                            class="tmn-dropdown-item"
                            ?kb-selected=${startIdx + idx === this._KBSelectedIndex}>
                            ${this.renderItem(item, startIdx + idx)}
                        </div>
                    `;
                })}
            </div>
            <div class="result-controls">
                <tmn-button
                    @click=${this.clearSelected}
                    variant="outlined"
                    .disabled=${controlsDisabled}
                    >Clear Selected</tmn-button
                >
                <tmn-button
                    .disabled=${controlsDisabled}
                    @click=${this.handleAddSelected}
                    color="primary"
                    variant="outlined"
                    >Add Selected Leagues</tmn-button
                >
            </div>`;
    }

    renderNoResults() {
        return html` <div class="results-list">
            <div class="tmn-dropdown-label">${this.renderLabel('Leagues')}</div>
            <div class="no-results">No Results</div>
        </div>`;
    }

    renderItem(item, idx) {
        const { displayKey, name } = item;
        const checked = this.selectedData?.includes(name);
        return html`<tmn-checkbox
            label=${displayKey}
            .value=${name}
            .checked=${checked}
            @tmn-switch-change=${this.handleItemSelected}
            >${displayKey}
        </tmn-checkbox> `;
    }

    getFilteredData() {
        const { searchValue, data } = this;
        if (!searchValue) {
            return data;
        }
        // todo multiword, letters, weight full match higher etc etc
        const matchSearchString = searchValue.toLowerCase();
        // sort of a hack but this allows us to easily have first letter only searching
        const useStartsWith = matchSearchString?.length === 1;
        const searchTerms = matchSearchString.split(' ');
        const searchDataFilter = (item) => {
            if (useStartsWith) {
                return item.displayKey.toLowerCase().startsWith(matchSearchString);
            }
            if (searchTerms.length > 1) {
                // match all items with all words (not necessarily just exact phrase (.i.e 'french league' would match french premier league))
                return searchTerms.every((t) => item.displayKey.toLowerCase().includes(t));
            }
            return item.displayKey.toLowerCase().includes(matchSearchString);
        };
        const sortFn = getSortFn(searchValue);
        return data.filter(searchDataFilter).sort((a, b) => sortFn(a.displayKey, b.displayKey));
    }

    handleAddSelected() {
        const { data, selectedData } = this;
        const selections = selectedData.map((name) => data.find((d) => d.name === name));
        const event = new CustomEvent('leagues-selected', {
            detail: {
                selections,
            },
            bubbles: true,
            composed: true,
        });
        this.dispatchEvent(event);
        this.clearSelected();
    }

    // todo label from props
    renderLabel(label) {
        return html` <h3>${label}</h3> `;
    }

    escapeQuotes(str) {
        const slashReplace = /\\/g;
        const quoteReplace = /'/g;
        return str.replace(slashReplace, '').replace(quoteReplace, "\\'");
    }

    valueChanged(e) {
        this._showAll = false;
        this.searchValue = e.target.value;

        // if (this.searchValue.length === 0) {
        //     this.visible = false;
        // } else {
        this.autocompleteSearchDebounced();
        //}
    }

    _focusin() {
        //if (this.searchValue !== '') this.visible = true;
        this.visible = true;
    }

    _blurInput() {
        this.shadowRoot.querySelector('input').blur();
    }

    clearSelected() {
        this.selectedData = [];
    }

    handleMenuOpenEvent() {
        if (this.searchValue !== '') {
            this.visible = true;
        }
    }

    handleMenuCloseEvent() {
        this.visible = false;
        this._blurInput();
    }

    handleMenuDefaultEvent() {
        this.visible = true;
        this._KBSelectedIndex = null;
    }

    handleUpdateKBIndex(index) {
        let count = _.flatten(this.searchResults.map((r) => r.items)).length;
        if (count && count > index) {
            this._KBSelectedIndex = index;
        }
    }

    handleItemSelected(e) {
        const { selectedData } = this;
        const itemId = e.detail.value;
        if (selectedData?.includes(itemId)) {
            this.selectedData = selectedData.filter((id) => id !== itemId);
        } else {
            this.selectedData = [...selectedData, itemId];
        }
    }

    selectItemAtIndex(index) {
        const itemAtIndex = this.shadowRoot.querySelectorAll('.tmn-dropdown-item')[index];
        //console.log(itemAtIndex);
        //this.selectItem(itemAtIndex);
    }

    getDropdownScrollDiv() {
        return this.shadowRoot.querySelector('.tmn-dropdown-items');
    }

    getSelectedItemDiv() {
        return this.shadowRoot.querySelector('.tmn-dropdown-item[kb-selected]');
    }

    cleanupWhitespace(query) {
        return query.replace(/\r?\n|\s+/g, ' ');
    }

    _handleGeneralKeyDown(e) {
        switch (e.key) {
            case 'Escape':
                //if (this.closeOnEscapePress) {
                this.handleMenuCloseEvent(e);
                //}
                break;
            default:
                break;
        }
    }
}

customElements.define('league-search', LeagueSearch);
// create search fn
function getSortFn(search) {
    return function sortFn(a, b) {
        // Compare the 2 keys
        const phraseMatchA = phraseMatch(a, search);
        const phraseMatchB = phraseMatch(b, search);
        const exactMatchA = exactMatch(a, search);
        const exactMatchB = exactMatch(b, search);
        if (exactMatchA && exactMatchB) {
            return normalAlphaSort(a, b);
        }
        if (phraseMatchA && phraseMatchB) {
            return normalAlphaSort(a, b);
        }
        if (exactMatchA && phraseMatchB) {
            return -1;
        }
        if (exactMatchB && phraseMatchA) {
            return 1;
        }
        if (phraseMatchA && !phraseMatchB) {
            return -1;
        }
        if (phraseMatchB && !phraseMatchA) {
            return 1;
        }
        return normalAlphaSort(a, b);
    };
}

function normalAlphaSort(a, b) {
    const nameA = a.toUpperCase(); // ignore upper and lowercase
    const nameB = b.toUpperCase(); // ignore upper and lowercase
    if (nameA < nameB) {
        return -1;
    }
    if (nameA > nameB) {
        return 1;
    }

    // names must be equal
    return 0;
}
const exactMatch = (str = '', test) => {
    return str.toLowerCase().replace(test.toLowerCase(), '').length === 0;
};

const startsWith = (str = '', test) => {
    return str.toLowerCase().startsWith(test.toLowerCase());
};

const phraseMatch = (str = '', test) => {
    return str.toLowerCase().includes(test);
};
